const htmlEscapes: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};

/** Escapes text so it can be inserted safely into an HTML template string. */
export function escapeHtml(value: string): string {
    return value.replace(/[&<>"']/g, c => htmlEscapes[c]);
}
